import React, { useEffect, useState } from "react";
import { formatPhone } from "../../utils/formatPhone";
import SettingsHome from "./pages/SettingsHome";
import AccountSettings from "./pages/AccountSettings";
import PersonalInformation from "./pages/PersonalInformation";
import SecuritySettings from "./pages/security/SecuritySettings";
import DeleteAccount from "./pages/DeleteAccount";
import ChangePassword from "./pages/security/ChangePassword";

const SettingsModal = ({
    settingsOpen,
    onClose,
    isDarkMode,
    toggleTheme,
    handleDeleteAccount,
    profile,
}) => {
    const [page, setPage] = useState("settings");

    useEffect(() => {
        if (!settingsOpen) {
            setPage("settings");
        }
    }, [settingsOpen]);



    if (!settingsOpen) return null;

    const handleBack = () => {
        switch (page) {
            case "account":
                setPage("settings");
                break;
            case "personal":
                setPage("account");
                break;
            case "security":
                setPage("account");
                break;
            case "change-password":
                setPage("security");
                break;
            case "delete":
                setPage("account");
                break;
            default:
                break;
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div
                className="modal-content"
                style={{ backgroundColor: "var(--secondary)" }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="settings-header">
                    {page !== "settings" ? (
                        <button
                            className="modal-back-btn"
                            onClick={handleBack}
                        >
                            <i className="fas fa-chevron-left" />
                        </button>
                    ) : (
                        <div className="modal-back-placeholder" />
                    )}

                    <h2>Settings</h2>

                    <div className="modal-back-placeholder" />
                </div>
                {/* SETTINGS HOME */}
                {page === "settings" && (
                    <SettingsHome
                        isDarkMode={isDarkMode}
                        toggleTheme={toggleTheme}
                        setPage={setPage}
                    />
                )}

                {/* ACCOUNT */}
                {page === "account" && (
                    <AccountSettings
                        onOpenPersonalInformation={() => setPage("personal")}
                        onOpenSecurity={() => setPage("security")}
                        onOpenDeleteAccount={() => setPage("delete")}
                    />
                )}

                {/* PERSONAL INFORMATION */}
                {page === "personal" && (
                    <PersonalInformation
                        profile={profile}
                        setPage={setPage}
                    />
                )}

                {/* CHANGE PASSWORD */}
                {page === "security" && (
                    <SecuritySettings
                        setPage={setPage}
                    />
                )}

                {page === "change-password" && (
                    <ChangePassword setPage={setPage} />
                )}

                {/* DELETE ACCOUNT */}
                {page === "delete" && (
                    <DeleteAccount
                        handleDeleteAccount={handleDeleteAccount}
                    />
                )}

                <button
                    onClick={onClose}
                    className="cancel-btn"
                >
                    Close
                </button>
            </div>
        </div>
    );
};

export default SettingsModal;